import { SliceProps } from "@/Slice/index"
import { GRichText } from "@/components"
import { Accordion, cn } from "@jog/react-components"
import { isFilled } from "@prismicio/helpers"

const alignments = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
}
export const ServiceAccordions = ({ className, slice: { primary, items } }: SliceProps<"accordions">) => (
    <div className={cn(className, "py-10")}>
        {isFilled.richText(primary.accordions_title) ? (
            <div className={cn("mt-3", alignments[primary.accordions_title_align])}>
                <GRichText field={primary.accordions_title} />
            </div>
        ) : null}
        <div className="mt-3 flex flex-col gap-1.75">
            {items.map((item, index) => (
                <Accordion
                    value={`accordion-${index}`}
                    key={index}
                    textColor={primary.accordion_text_color || ""}
                    bgColor={primary.accordion_bg_color || ""}
                    title={<GRichText paragraphClass="mt-2.5" field={item.accordion_title} />}
                    content={<GRichText paragraphClass="mt-2.5" field={item.accordion_content} />}
                />
            ))}
        </div>
    </div>
)

export const MarketAccordions = ({ className, slice: { primary, items } }: SliceProps<"accordions">) => (
    <div className={cn(className, "grid grid-cols-5 p-4 lg:p-10")}>
        <div className="col-span-full lg:col-span-3 lg:col-start-2">
            {isFilled.richText(primary.accordions_title) ? (
                <div className={cn("mt-3", alignments[primary.accordions_title_align])}>
                    <GRichText field={primary.accordions_title} />
                </div>
            ) : null}
            <div className="mt-3 flex flex-col gap-1.75">
                {items.map((item, index) => (
                    <Accordion
                        value={`accordion-${index}`}
                        key={index}
                        textColor={primary.accordion_text_color || ""}
                        bgColor={primary.accordion_bg_color || ""}
                        title={<GRichText paragraphClass="mt-2.5" field={item.accordion_title} />}
                        content={<GRichText paragraphClass="mt-2.5" field={item.accordion_content} />}
                    />
                ))}
            </div>
        </div>
    </div>
)
